import imageCompression from "browser-image-compression";

/******************************* Constant Variable and Function Declaration  ********************************** */

// RGB hex codes for official BuildID colors
// If you change them here, also change them in App.css

export const BIBlue = "#083DB8";
export const BIYellow = "#FFBC0A";
export const BIGrey = "#8D8D8D";
export const BILightGrey = "#CCCCCC";
export const BIWhite = "#FFFFFF";
export const BIBlack = "#000000";
export const BIRed = "#FA0000";
export const BILightRed = "#FABEBE";
export const BIGreen = "#28A745";
export const BILightYellow = "#FFEEBF";
export const BILightGreen = "#c7d9bb";
export const BILightOrange = "#fbd7bd";
export const BIBrown = "#6f360f";

export const mapStyle = [
  {
    featureType: "transit",
    elementType: "all",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "poi",
    stylers: [{ visibility: "off" }],
    elementType: "all"
  },
  {
    featureType: "road.highway",
    elementType: "labels.text",
    stylers: [{ visibility: "off" }] // Hides highway road numbers
  },
  {
    featureType: "road.highway",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }] // Hides highway icons (optional)
  }
];

export const EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/*********** Constant Function ***************/

export const lightenHexColor = (hex, percent) => {
  let r = parseInt(hex?.substr(1, 2), 16);
  let g = parseInt(hex?.substr(3, 2), 16);
  let b = parseInt(hex?.substr(5, 2), 16);

  r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
  g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
  b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));

  return `rgb(${r},${g},${b})`;
};

// Checks if input string is an ISO Date
export function isISODate(string) {
  let date = new Date(string);
  return date.toString() !== "Invalid Date";
}

// Formats ISO date string to {MONTH DD, YYYY}
export function isoToMonthDateYear(isoString) {
  return new Date(isoString).toLocaleDateString([], {
    month: "long",
    year: "numeric",
    day: "numeric"
  });
}

export const imageCompress = async (file, options) => {
  if (file.type === "image/webp") {
    return Promise.resolve(file);
  }

  let defaultOptions = options
    ? { ...options }
    : {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };

  try {
    const compressedFile = await imageCompression(file, defaultOptions);

    const convertBlobToFile = (blob, fileName) => {
      // Create a File object from the Blob
      const file = new File([blob], fileName, {
        type: blob.type,
        lastModified: new Date().getTime()
      });
      return file;
    };
    return convertBlobToFile(compressedFile, file.name);
  } catch (error) {
    console.log("imageCompress->Error During Image Compression ", error);
    return Promise.resolve(file);
  }
};
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const base64ToFile = (base64String, fileName, mimeType) => {
  if (!base64String || typeof base64String !== "string" || !base64String.includes(",")) {
    console.error("base64ToFile-> Invalid base64 string:", base64String);
    return null;
  }

  const byteCharacters = atob(base64String.split(",")[1]);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new File([byteArray], fileName, { type: mimeType });
};

export const loadBitMovinPlayerScript = () => {
  return new Promise((resolve, reject) => {
    if (
      document.querySelector(
        "script[src='https://cdn.bitmovin.com/player/web/8/bitmovinplayer.js']"
      )
    ) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = "https://cdn.bitmovin.com/player/web/8/bitmovinplayer.js";
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

const Colors = {
  LightGray: "#e4e4e4",
  Black: "#000000",
  MainBlue: "#162D61",
  // MainBlue: '#083db8',
  LighPink: "#f0dcdc",
  SecondaryLightBlue: "#78C1F3",
  Yellow: "#ffbc0a",
  TaupeGray: "#8d8d8d",
  white: "#ffffff",
  defaultNavigatorBarBackgroundColor: "#3498DB",
  defaultNavigatorBarColor: "white",
  DecTecBlue: "#10799F",
  Success: "#42B53D",
  Error: "#E65555",
  BrightOrange: "#EBBC3D",
  Gray94: "#F0F0F0",
  LightYellow: "#FFEEBF",
  Red: "#A52A2A",
  DisabledRed: "#f0dcdc",
  FadeGray: "#c8c8c8",
  GrayTint: "#e0dcdc",
  GrayShade1: "#ebebeb",
  GrayDark: "#4f4f4f",
  Transparent: "transparent",
  DarkGray: "#504c4c",
  IconGray: "#8d8e8f",
  SemiTransperant: "rgba(52, 52, 52, 0.45)",

  // NEW COLOR --->
  Green_Light: "#c6d9bb",
  Green_Dark_Text: "#215112",
  Yellow_Light: "#fee8ab",
  Yellow_Dark_Text: "#684f0a",
  Red_Light: "#f5a9a9",
  Red_Dark_Text: "#9b2020",
  Orange_Light: "#fbd6bc",
  Brown_Dark_Text: "#804b28",
  Green: "#00D100",
  RedSimple: "#FF0000",
  transparentGray: "#f4f4f5"
};
export default Colors;
